export const ActivityData = [
    {
      "id": 1,
      "title": "Leads",
      "count": 5
    },
    {
      "id": 2,
      "title": "File Login",
      "count": 7
    },
    {
      "id": 3,
      "title": "IMD Collection",
      "count": 56
    },
    {
      "id": 4,
      "title": "OTC Clearance",
      "count": 89
    },
    {
      "id": 5,
      "title": "EMI Collection",
      "count": 6
    },
    {
      "id": 6,
      "title": "Channel Partner Visit",
      "count": 65
    },
    {
      "id": 7,
      "title": "Marketing Activity",
      "count": 95
    },
    {
      "id": 8,
      "title": "Authority Visit",
      "count": 43
    },
    {
      "id": 9,
      "title": "Desk Work",
      "count": 32
    },
  ]

